import styled from 'styled-components';

export const HelpWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export const HelpTrigger = styled.button`
    display: flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: inherit;
    cursor: pointer;
    text-align: inherit;

    &:hover {
        background: #eee;
    }
`;

export const HelpDropdown = styled.div`
    position: absolute;
    right: 0;
    top: 100%;
    margin-top: 4px;
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors.border.ccc};
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    min-width: 160px;
    z-index: 100;
    overflow: hidden;
`;

export const HelpItem = styled.a`
    display: block;
    width: 100%;
    padding: 8px 14px;
    border: none;
    background: none;
    font-family: inherit;
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.heading};
    cursor: pointer;
    text-decoration: none;
    transition: background 0.1s;

    &:hover,
    &:focus-visible {
        background: rgb(244, 248, 252);
    }
`;

export const HelpDivider = styled.div`
    border-top: 1px solid ${({ theme }) => theme.colors.border.ccc};
    margin: 4px 0;
`;
